import axios from 'axios';

export const createAllPaySubscription = async (subscriptionData, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/allpay/create-subscription`;
    try {
      const response = await axios.post(apiUrl, subscriptionData, {
        headers: {
          authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  };

  export const cancelSubscription = async ({ subscriptionId }, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/allpay/cancel`;
    try {
      const response = await axios.post(apiUrl, { subscriptionId }, {
        headers: {
          authorization: `Bearer ${token}`,
        }
      });
      return response;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  };

  export const createYooKassaSubscription = async (subscriptionData, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/yookassa/create-subscription`;
    try {
      const response = await axios.post(apiUrl, subscriptionData, {
        headers: {
          authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating subscription:', error);
      throw error;
    }
  };

  export const createYooKassaPayment = async (paymentData, token) => {
    const apiUrl = `${process.env.REACT_APP_SERVER_URL}/yookassa/create-payment`;
    try {
      const response = await axios.post(apiUrl, paymentData, {
        headers: {
          authorization: `Bearer ${token}`,
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  };
